import module from 'module';
import $ from "jquery";

import templateUrl from './auction-tag-view.template.html';
import './auction-tag-view.style.less';

class AuctionTagViewComponent {
  constructor(http, nav, printService, $timeout, $routeParams, $location) {
    this.http = http;
    this.nav = nav;
    this.printService = printService;
    this.$timeout = $timeout;
    this.$routeParams = $routeParams;
    this.$location = $location;
  }

  $onInit() {
    this.selectedIds = this.$routeParams.selectedIds.map(Number);
    this.$timeout(() => {
      this.http.post(`/print/AUCTION_TAG/json`, {
        pawnItemIds: this.selectedIds
      }).success(doc => {
        this.doc = doc;

        return this.printService.printToContainer(doc, {
          autoPrint: false,
          backgroundEnabled: true,
          container: $('.iframe-preview')
        });
      });
    });
  }

  redirectBack() {
    this.nav.back()
  }

  print() {
    this.printService.printToContainer(this.doc, {
      autoPrint: true,
      backgroundEnabled: false,
      container: $('.iframe-invisible')
    });
  }

  $onDestroy() {
    if (this.selectedIds) {
      this.$location.search({});
    }
  }
}

module.component('auctionTagView', {
  templateUrl: templateUrl,
  controller: AuctionTagViewComponent
});